import httpHandler from '@/scripts/helpers/http-status-code-handler'

export default {
  namespaced: true,
  actions: {
    async apiCall({ commit }, data) {
      return httpHandler.apiCall(
        commit,
        `${process.env.VUE_APP_API_ENDPOINT}/Notes`,
        data,
      )
    },
  },
}
